import { Box } from "@mui/material";
import backgroundImage from "../../assets/img/auth/background.png";
import Logo from "../../components/logo/Logo";
import { Link } from "react-router-dom";

const AuthContainer = ({ children }) => {

    return (
        <Box
            sx={{
                minHeight: "100vh",
                backgroundColor: "#FAFAFA",
                backgroundImage: `url(${backgroundImage})`,
                backgroundSize: "cover",
            }}
        >
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", p: 2 }}>
                <Logo />
                <Link to="/" className="btn btn-blue" style={{ width: "100px" }}>داشبورد</Link>
            </Box>
            <Box
                sx={{
                    minHeight: "calc(100vh - 90px)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    gap: "20px",
                }}
            >
                {children}
            </Box>
        </Box>
    );
};

export default AuthContainer;